import { ConfigTaskTypes } from './actionTypes';

const INIT_STATE = {
  configTasks: [],
  configTaskDetail: {},
  configTaskAdd: {},
  CountItems: 0,
  deleteId: undefined,
  configTaskUpdate: {},
  error: {},
  success: '',
  isLoading: false,
};

const ConfigTasks = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ConfigTaskTypes.GET_CONFIG_TASK:
      return {
        ...state,
        isLoading: true,
      };
    case ConfigTaskTypes.GET_CONFIG_TASK_SUCCESS:
      console.log(action);
      return {
        ...state,
        configTasks: action.payload.configTaskData,
        CountItems: action.payload.CountItems,
        configTaskAdd: {},
        isLoading: false,
      };
    case ConfigTaskTypes.GET_CONFIG_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
        configTasks: [],
        configTaskAdd: {},
        isLoading: false,
      };

    case ConfigTaskTypes.GET_CONFIG_TASK_DETAIL_SUCCESS:
      return {
        ...state,
        configTaskDetail: action.payload,
      };

    case ConfigTaskTypes.GET_CONFIG_TASK_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ConfigTaskTypes.ADD_CONFIG_TASK:
      return {
        ...state,
        isLoading: true,
      };
    case ConfigTaskTypes.ADD_CONFIG_TASK_SUCCESS:
      return {
        ...state,
        configTaskAdd: action.payload,
      };
    case ConfigTaskTypes.ADD_CONFIG_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ConfigTaskTypes.DELETE_CONFIG_TASK:
      return {
        ...state,
        isLoading: true,
      };
    case ConfigTaskTypes.DELETE_CONFIG_TASK_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case ConfigTaskTypes.DELETE_CONFIG_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ConfigTaskTypes.UPDATE_CONFIG_TASK:
      return {
        ...state,
        isLoading: true,
      };

    case ConfigTaskTypes.UPDATE_CONFIG_TASK_SUCCESS:
      return {
        ...state,
        configTaskUpdate: action.payload,
      };
    case ConfigTaskTypes.UPDATE_CONFIG_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      break;
  }
  return state;
};

export default ConfigTasks;
